import {
  put,
  call,
  takeLatest,
} from 'redux-saga/effects';
// constants
import * as C from '../../constants';
// utilities
import { ENDPOINTS } from '../../utilities/http/endpoints';
// utilities
import * as U from '../../utilities';
// features
import { loginRoutine } from './routines';
import {
  loaderRoutine,
} from '../loader/routines';
//////////////////////////////////////////////////

// TODO: we need solution for check token
function* sessionSaga() {
  try {
    yield put(loaderRoutine.show());

    const token = U.getAuthTokenFromStorage();

    if (U.isNotNilAndNotEmpty(token)) {
      yield put(loginRoutine.success());
      yield put(loaderRoutine.hide());
    } else {
      yield put(loginRoutine.failure());
      yield put(loaderRoutine.hide());
    }
  } catch (error) {
    yield call(U.handleException, error, 'sessionSaga exception');

    yield put(loginRoutine.failure());
    yield put(loaderRoutine.hide());
  }
}

function* handleLoginRequest({ payload }) {
  try {
    yield put(loaderRoutine.show());

    const { password, username } = payload;

    const body = U.getFormData({ password, username, grant_type: 'password' });

    const res = yield call(U.sendRequest, 'post', ENDPOINTS.login, {
      body,
      headers: {
        [C.CONTENT_TYPE]: C.MULTIPART_FORM_DATA,
      },
    });

    const { data, error, status } = res;

    if (U.isResponseSuccess(status)) {
      yield call(U.setAuthTokenToStorage, data.access_token);

      yield put(loginRoutine.success());
      yield put(loaderRoutine.hide());
    } else {
      yield call(U.showToastrMessage, 'error', error);
      yield call(U.handleFailResponse, res, 'handleLoginRequest fail', true);

      yield put(loginRoutine.failure());
      yield put(loaderRoutine.hide());
    }
  } catch (error) {
    yield call(U.handleException, error, 'handleLoginRequest exception');

    yield put(loginRoutine.failure());
    yield put(loaderRoutine.hide());
  }
}

function* loginWatcherSaga() {
  yield takeLatest(loginRoutine.TRIGGER, handleLoginRequest);
}

export default loginWatcherSaga;

export {
  sessionSaga,
  handleLoginRequest,
};
